import { render, staticRenderFns } from "./CaptureRecordList.vue?vue&type=template&id=4f7c3960&scoped=true&"
import script from "./CaptureRecordList.vue?vue&type=script&lang=js&"
export * from "./CaptureRecordList.vue?vue&type=script&lang=js&"
import style0 from "./CaptureRecordList.vue?vue&type=style&index=0&id=4f7c3960&scoped=true&lang=css&"
import style1 from "./CaptureRecordList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c3960",
  null
  
)

/* custom blocks */
import block0 from "./CaptureRecordList.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7c3960')) {
      api.createRecord('4f7c3960', component.options)
    } else {
      api.reload('4f7c3960', component.options)
    }
    module.hot.accept("./CaptureRecordList.vue?vue&type=template&id=4f7c3960&scoped=true&", function () {
      api.rerender('4f7c3960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/PlaceFloorPlans/CaptureRecordList.vue"
export default component.exports